import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response';
import { AuditLog } from '../../models/audit-log';

@Injectable({ providedIn: 'root' })
export class AuditLogsService {
  constructor(private http: HttpClient) {}

  getLogs(
    page: number,
    size: number,
    entityName: string,
    entityId: string,
    adminUserId: string,
    search: string
  ): Observable<ApiResponse<AuditLog[]>> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (entityName.trim()) {
      params = params.set('entityName', entityName.trim());
    }

    if (entityId.trim()) {
      params = params.set('entityId', entityId.trim());
    }

    if (adminUserId.trim()) {
      params = params.set('adminUserId', adminUserId.trim());
    }

    if (search.trim()) {
      params = params.set('search', search.trim());
    }

    return this.http.get<ApiResponse<AuditLog[]>>(
      `${environment.apiBaseUrl}/admin/audit-logs`,
      { params }
    );
  }
}